import { LS_PREFIX } from "../config";

// Get Feature Flag
export const ff = (key) => {
    /* Sample of official launch
    const time = Math.floor((new Date).getTime() / 1000);
    if (key === 'premium' && time > 1683993600) {
         return true;
    }*/

    return !!localStorage.getItem(`${LS_PREFIX}ff_${key}`);
}

// Set Feature Flag
export const setff = (key, state) => {
    if (state) {
        localStorage.setItem(`${LS_PREFIX}ff_${key}`, 'true');
    } else {
        localStorage.removeItem(`${LS_PREFIX}ff_${key}`);
    }
}
